import script from "./ProgramVersionDesignFromBenchling.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgramVersionDesignFromBenchling.vue?vue&type=script&setup=true&lang=ts"

import "./ProgramVersionDesignFromBenchling.vue?vue&type=style&index=0&id=7b819b50&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b819b50"]])

export default __exports__